/**
 * InventoryPage Component
 *
 * Main inventory landing page at /inventory route.
 * Renders the Stock Overview Dashboard.
 *
 * User Story: US-P6-001 - Inventory Management
 * Step 4: Stock Overview Dashboard
 */

import { PageLayout } from '@/components/layout'
import StockOverviewDashboard from '@/components/inventory/StockOverviewDashboard'

/**
 * InventoryPage Component
 *
 * @param {Object} props
 * @param {Object} props.user - Current user object
 * @param {Function} props.onLogout - Logout handler
 */
export default function InventoryPage({ user, onLogout }) {
  return (
    <PageLayout user={user} onLogout={onLogout}>
      <div className="space-y-6">
        {/* Page Header */}
        <div>
          <h1 className="text-3xl font-bold text-foreground">Inventory</h1>
          <p className="text-muted-foreground">
            Manage stock levels, track purchases, and monitor material usage
          </p>
        </div>

        {/* Stock Overview Dashboard */}
        <StockOverviewDashboard />
      </div>
    </PageLayout>
  )
}
